import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Col, Spinner } from "reactstrap"
import {
  useResolveQueryStepsQuery,
  useUpdateKycStepMutation,
} from "store/api/kyc/kyc"

const KYCPrevButton = ({ kycData, disabled, ButtonHtml = null }) => {
  const { kycSteps } = useSelector((state) => state.common)
  const [prevStep, setPrevStep] = useState(null)
  const [updateStep, { isLoading }] = useUpdateKycStepMutation()
  const { data: querySteps } = useResolveQueryStepsQuery()

  const goToStep = async () => {
    try {
      await updateStep({ kyc_status: prevStep }).unwrap()
      window.location.reload()
    } catch (error) {}
  }

  function getPreviousKey(currentStep) {
    let prevKey = null

    for (let i = 0; i < kycSteps.length; i++) {
      const stepKeys = kycSteps[i].key
      const keyIndex = stepKeys.indexOf(currentStep)
      if (keyIndex !== -1) {
        if (keyIndex > 0) {
          prevKey = stepKeys[keyIndex - 1]
        } else if (i > 0) {
          const prevStepKeys = kycSteps[i - 1].key
          prevKey = prevStepKeys[prevStepKeys.length - 1]
        } else {
          prevKey = null
        }
        break
      }
    }

    if (
      prevKey === "GST_WAIVER" &&
      !kycData?.investorCompanyDetails?.gst_waiver
    ) {
      prevKey = "GST_DETAILS"
    }

    if (
      prevKey === "GST_DETAILS" &&
      kycData?.investorCompanyDetails?.gst_waiver
    ) {
      prevKey = "PAN_GST"
    }

    return prevKey
  }
  useEffect(() => {
    const currentStatus = querySteps?.data?.current_step || kycData?.kyc_status
    const normalizedStatus =
      currentStatus === "BANK_DETAILS" ? "BANK_VERIFICATION" : currentStatus

    setPrevStep(getPreviousKey(normalizedStatus))
  }, [kycData, querySteps])

  return (
    <>
      {prevStep && (
        <Col md="6" lg="6">
          <button
            type="button"
            onClick={() => goToStep()}
            disabled={disabled}
            className="btn btn-primary prev-button w-100"
          >
            {isLoading ? <Spinner size={"sm"} /> : "Previous Page"}
          </button>
        </Col>
      )}
      <Col md={prevStep ? "6" : "12"} lg={prevStep ? "6" : "12"}>
        {ButtonHtml}
      </Col>
    </>
  )
}

export default KYCPrevButton
